import { getStage } from './runtimeConfig'

const env = process.env
const stage = getStage()

export { env, stage }
